var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBusinessCreditScore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 36,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#BusinessCreditScore_svg__a)",
  d: "M11.912.334q4.992 0 8.016 2.736Q23 5.758 23 10.51q0 4.704-3.024 7.2-3.024 2.448-8.016 2.448l-.192 3.696H5.864l-.24-8.16h2.16q4.176 0 6.432-1.104t2.256-4.032q0-2.112-1.248-3.36-1.2-1.248-3.312-1.248-2.208 0-3.456 1.2-1.2 1.2-1.2 3.312H.92Q.872 7.534 2.168 5.23t3.792-3.6Q8.504.334 11.912.334m-3.12 34.992q-1.824 0-3.024-1.104-1.152-1.152-1.152-2.832t1.152-2.784q1.2-1.152 3.024-1.152 1.776 0 2.928 1.152 1.152 1.104 1.152 2.784t-1.152 2.832q-1.152 1.104-2.928 1.104"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "BusinessCreditScore_svg__a",
  x1: 25.154,
  x2: -0.846,
  y1: 17.99,
  y2: 17.99,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00CBA9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#09F"
})))));
export default SvgBusinessCreditScore;